import styled from '@emotion/styled';
import { spacing, breakpoints } from '$variables/theme';

export const MainContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  justify-content: center;
  display: flex;
  overflow: hidden;
  margin-bottom: ${spacing.xSmall};

  @media (max-width: ${breakpoints.mediumStart}) {
    padding-top: ${spacing.xSmall};
  }
`;

// 16px is total of body's martginTop (8px) and marginBottom (8px)
export const SpinnerContainer = styled.div`
  height: calc(100vh - 16px);
  display: flex;
  align-items: center;
`;

export const AppContainer = styled.div`
  width: 100%;
  @media (max-width: ${breakpoints.small}) {
    display: none;
  }
`;
